// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2LcoH","container":"index-module--container--2AIg3","privacidade":"index-module--privacidade--3Nr7y"};